document.addEventListener('DOMContentLoaded', function () {
    var fixedMessageSection = document.getElementById('shopify-section-fixed-message');
    var closeButton = document.querySelector('.js-close-fixed-message');
    
    // Check if the 'fixed-message' cookie is set to 'dismiss'
    var fixedMessageCookie = Cookies.get('fixed-message');
    
    if (fixedMessageCookie !== 'dismiss') {
        // Show the message by removing 'is-hidden' class if the cookie is not set
        fixedMessageSection.classList.remove('is-hidden');
        
        // Attach the event listener to the close button
        closeButton.addEventListener('click', function () {
            // Hide the fixed message and set a cookie
            fixedMessageSection.classList.add('is-hidden');
            
            // Set the 'fixed-message' cookie to 'dismiss' for 30 days
            Cookies.set('fixed-message', 'dismiss', {
                expires: 30, 
                sameSite: 'Lax', 
                secure: true // Ensure cookie is set over HTTPS
            });
        });
    }
});
